import app from 'app';
import ready from 'utils/ready';
import blog from './blog/main';
import categoryModal from './blog/category-modal';

app.add({
  blog,
  categoryModal,
});

ready(app.mount);
